<template>
    <VJoyPanel data-testid="search-spelling-correction">
        <template #panel-body>
            <VJoyWrapper column-gap="5">
                <MaltImg src="/hopsearch/no-results.png" alt="No result" height="62" />
                <VJoyWrapper direction="column" align="flex-start" no-margin row-gap="0">
                    <h2 class="search-spelling-correction__title">{{ $t('search.spelling.correction.title') }}</h2>
                    <p v-html="$t('search.spelling.correction.suggestion', [spellingCorrection?.searchUrl, spellingCorrection?.suggestion])" />
                </VJoyWrapper>
            </VJoyWrapper>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {MaltImg} from '#components';
    import {VJoyPanel, VJoyWrapper} from '@maltjoy/core-vue';
    import {useSearchFeaturesStore} from '../stores/search-features.store';

    const searchFeaturesStore = useSearchFeaturesStore();
    const {spellingCorrection} = storeToRefs(searchFeaturesStore);
</script>

<style lang="scss">
    .search-spelling-correction {
        &__title {
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-secondary-200);
        }
    }
</style>
